// extracted by mini-css-extract-plugin
export default {"footer":"dark_footer__BNrcZ","heartOverflow":"dark_heartOverflow__nYkwv","heart":"dark_heart__Usrhp"};